import {getField, updateField} from 'vuex-map-fields';

export default {
    modules: {
        StoreDocList: {
            namespaced: true,
            state: {
                itemList: [],
                searchTerm: null,
                searchTermFile: null,
                selectedItemList: [],
                editedItem: {name: null, description: null},
                options: {
                    page: 1,
                    itemsPerPage: 50,
                    sortBy: ['title'],
                    sortDesc: [false],
                    multiSort: false,
                    mustSort: true,
                    descending: false,

                },
                totalRecords: 0,
                loading: false,
                deleteLoading: false,
                saveLoading: false,
                addLoading: false,
                previewLink: null,
            },

            actions: {
                async fetchItemList(ctx) {
                    ctx.commit('updateLoading', true)
                    const requestParams = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                        },
                    };
                    const page = ctx.state.options.page
                    const page_size = ctx.state.options.itemsPerPage
                    let order_by = ctx.state.options.sortBy[0]
                    if (ctx.state.options.sortDesc[0] == true) {
                        order_by = '-' + order_by
                    }
                    let url = "/api/store_doc/?page=" + page + "&page_size=" + page_size + "&order_by=" + order_by
                    if (ctx.state.searchTerm != null) {
                        url += '&search_term=' + ctx.state.searchTerm
                    }
                    if (ctx.state.searchTermFile != null) {
                        url += '&file_search_term=' + ctx.state.searchTermFile
                    }
                    let res = await fetch(url, requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateLoading', false)
                        return
                    }
                    const resJson = await res.json();
                    const totalRecords = resJson.count
                    const rowList = resJson.results

                    ctx.commit('updateItemList', rowList)
                    ctx.commit('updateTotalRecords', totalRecords)
                    ctx.commit('updateLoading', false)
                },
                async fetchDeleteRow(ctx, item) {
                    ctx.commit('updateDeleteLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    const requestParams = {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                    };
                    const res = await fetch("/api/store_doc/" + item.id + '/', requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this.$root.$store._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateDeleteLoading', false)
                        return
                    }
                    const itemList = ctx.state.itemList.filter(row => row.id != item.id)
                    ctx.commit('updateItemList', itemList)
                    ctx.commit('updateTotalRecords', this.getTotalRecords - 1)
                    ctx.commit('updateDeleteLoading', false)
                },
                async fetchSaveItem(ctx, item) {
                    // console.log('fetchSaveItem')
                    // console.log(item)
                    ctx.commit('updateSaveLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    const requestParams = {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: JSON.stringify({
                            'title': item.name,
                            'description': item.description,
                        })
                    };
                    const res = await fetch("/api/store_doc/" + item.id + "/", requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateSaveLoading', false)
                    }
                    let rowListEdited = []
                    const result = await res.json()
                    for( let rowListItem of  ctx.state.rowList) {
                        if (rowListItem.id === item.id)
                            rowListEdited.push(result)
                        else
                            rowListEdited.push(rowListItem)
                    }
                    ctx.commit('updateItemList', rowListEdited)
                    ctx.commit('updateSaveLoading', false)
                },
                async fetchAddItem(ctx, item) {
                    // console.log('fetchAddItem')
                    // console.log(item)
                    ctx.commit('updateAddLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    const requestParams = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: JSON.stringify({
                            'title': item.name,
                            'description': item.description,
                        })
                    };
                    const res = await fetch("/api/store_doc/", requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateAddLoading', false)
                        return
                    }
                    const result = await res.json()
                    let rowList = ctx.state.rowList
                    rowList.push(result)
                    ctx.commit('updateItemList', rowList)
                    ctx.commit('updateAddLoading', false)
                },
            },

            mutations: {
                updateField,
                updateItemList(state, rowList) {
                    state.itemList = rowList
                },
                updateTotalRecords(state, totalRecords) {
                    state.totalRecords = totalRecords
                },
                updateLoading(state, loading) {
                    state.loading = loading
                },
                updateDeleteLoading(state, deleteLoading) {
                    state.deleteLoading = deleteLoading
                },
                updateSaveLoading(state, saveLoading) {
                    state.saveLoading = saveLoading
                },
                updateAddLoading(state, addLoading) {
                    state.addLoading = addLoading
                },
                updateSearchTerm(state, searchTerm) {
                    state.searchTerm = searchTerm
                }
            },

            getters: {
                getField,
                getRowList(state) {
                    return state.itemList
                },
                getTotalRecords(state) {
                    return state.totalRecords
                },
            }
        }
    }
}